module.exports = __webpack_public_path__ + "img/logo.644d4efd.svg";